import React from "react";
import styles from "./mission.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";

const Mission = () => {
  return (
    <React.Fragment>
      <Container>
        <div className={styles.main_section}>
          <Heading>Our Mission our Vision</Heading>
          <Paragraph color="#62677A">
            {" "}
            Guiding principles that drive our commitment to excellence and
            innovation in <br /> global trade.
          </Paragraph>
        </div>
        <Row>
          <Col md={6} sm={12}>
            <div className={styles.right_section}>
              <div className={styles.textOverlay}>
                <h6>Mission</h6>
                <p>
                  At CrossBorder BTC, our mission is to simplify and enhance
                  global trade by managing the entire sourcing and transaction
                  process. We aim to deliver
                </p>
              </div>
            </div>

            <div className={styles.list}>
              <ul>
                <li>
                  Ensuring that every client receives personalized solutions
                  tailored to their unique needs.
                </li>
                <li>
                  Prioritizing efficiency and cost-effectiveness for maximum
                  client value.
                </li>
                <li>
                  Taking care of every step, from sourcing to delivery, with
                  precision and transparency.
                </li>
                <p>
                  Our unwavering dedication to overcoming challenges ensures
                  that we maintain a near 100% success rate in delivering
                  reliable and impactful solutions.
                </p>
              </ul>
            </div>
          </Col>
          <Col md={6} sm={12}>
            <div className={styles.leftSection}>
              <div className={styles.textOverlay}>
                <h6>Vision</h6>
                <p>
                  Our vision is to become the world's most trusted and
                  innovative commodity specialist firm, delivering...
                </p>
              </div>
            </div>

            <div className={styles.list}>
              <ul>
                <li>
                  Access to the broadest and most dependable supply of resources
                  and products globally.
                </li>
                <li>
                  Empowering a greener future through solar energy, renewable
                  resources, and eco-friendly innovations.
                </li>
                <li>
                  Expanding our presence and services to meet the needs of
                  international clients with cutting-edge solutions.
                </li>
                <p>
                  We are committed to supporting industries and communities by
                  fostering growth, building connections, and ensuring
                  excellence in every transaction.
                </p>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Mission;
